var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-app',{ref:"app"},[(!_vm.hideHeader)?_c('Header',{ref:"header"}):_vm._e(),_c('v-main',[_c('router-view',{staticClass:"box-container elevation-7"})],1),(!_vm.hideFooter)?_c('Footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }